/*
 * Copyright © Manatee. 2026 All Rights Reserved.
 * Proprietary and confidential.
 */

/**
 * The Stream data source. Today it composes a stream from one agent run; when nexus ships
 * `/v1/streams`, this is the only file that changes — surfaces consume `getStream` and the handoff
 * actions, never the underlying run/queue endpoints.
 */

import type { ApiResult } from "./client";
import { claim, resolve } from "./queue";
import { runDetail } from "./runs";
import { streamFromRunDetail, type Stream } from "../lib/stream";

export type { Stream } from "../lib/stream";

export async function getStream(id: string): Promise<ApiResult<Stream>> {
  const detail = await runDetail(id);
  if (!detail.ok) {
    return detail;
  }
  return { ok: true, value: streamFromRunDetail(detail.value) };
}

/** Take a handoff so colleagues see someone is on it. */
export const claimHandoff = claim;

/** Close a handoff; the note becomes the audit trail. */
export const resolveHandoff = resolve;
